export const SIDEBAR_COLLAPSED_WIDTH = 64;
/** Fits nav labels without excess empty space; user can drag wider. */
export const DEFAULT_SIDEBAR_WIDTH = 220;
export const MIN_SIDEBAR_WIDTH = 168;
export const MAX_SIDEBAR_WIDTH = 300;

export function clampSidebarWidth(width: number): number {
  return Math.min(MAX_SIDEBAR_WIDTH, Math.max(MIN_SIDEBAR_WIDTH, Math.round(width)));
}
